import Vue from 'vue';

Vue.mixin({
    data() {
        return {
            dataatual: null,
            dayName: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            monName: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Agosto", "Outubro", "Novembro", "Dezembro"],
            urlsuporte: null,
            viewFilterReport: false,
            data_inicio: "",
            data_fim: "",
            verificaDataInicial: false,
            format_hora: null,
            dataNow: moment().format("YYYY/MM/DD"),
        }
    },
    computed: {
        authsuporte() {
            return {
                suporte_token: this.$store.state.suporte_token,
                suporte_user: this.$store.state.suporte_user,
            }
        },
    },
    watch: {
        data_inicio: function (val) {

            if (val != "" && this.data_fim == "") {
                this.verificaDataInicial = true;
            } else {
                this.verificaDataInicial = false;
            }
        },
    },
    mounted() {
        this.getDataAtual();
    },
    methods: {
        viewFilters: function () {
            this.viewFilterReport = !this.viewFilterReport;
        },
        print() {
            var css = "@page {margin: 1cm 1.25cm 1.25cm 1.25cm !important;}",
                head = document.head || document.getElementsByTagName("head")[0],
                style = document.createElement("style");

            style.type = "text/css";
            style.media = "print";

            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }

            head.appendChild(style);

            const modal = document.getElementById("boxPrint");
            const cloned = modal.cloneNode(true);
            let section = document.getElementById("print");

            if (!section) {
                section = document.createElement("div");
                section.id = "print";
                document.body.appendChild(section);
            }

            section.appendChild(cloned);

            window.print();

            section.innerHTML = "";
        },
        async printHtml() {
            const el = this.$refs.printMe;
            const options = {
                type: "dataURL",
            };
            const printCanvas = await this.$html2canvas(el, options);

            const link = document.createElement("a");

            link.setAttribute("download", document.getElementsByTagName("title")[0].innerText + ".png");

            link.setAttribute(
                "href",
                printCanvas.replace("image/png", "image/octet-stream")
            );
            link.click();
        },
        getDataAtual() {
            let now = new Date();
            this.dataatual = this.dayName[now.getDay()] +
                ", " +
                now.getDate() +
                " de " +
                this.monName[now.getMonth()] +
                " de " +
                now.getFullYear();
        },
        limparFiltrosGeral() {
            document.querySelector('form').reset()
        }
    }
})
